'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight, Gift, Users, CalendarCheck, PartyPopper, Package, Sparkles, Rocket, type LucideIcon } from 'lucide-react';
interface OfferCard {
  title: string;
  description: string;
  benefits: {
    icon: LucideIcon;
    text: string;
  }[];
  href: string;
  ctaLabel: string;
  accent: 'blue' | 'emerald';
}
const cards: OfferCard[] = [{
  title: 'Host experiences at your place',
  description: 'Brands want real people to try their products. Offer your office, campus, or public venue as a testing ground and unlock free samples, pop-ups, and activations for your team.',
  benefits: [{
    icon: Gift,
    text: 'Free & discounted products for your people'
  }, {
    icon: Users,
    text: 'Boost morale with fun brand experiences'
  }, {
    icon: CalendarCheck,
    text: 'Seamless pop-ups, sampling & drop-offs'
  }],
  href: '/for-places',
  ctaLabel: 'Learn more about Sizzle for Places',
  accent: 'blue'
}, {
  title: 'Get free or discounted product for your next event',
  description: "Hosting a gathering, launch, or community event? Brands are looking for the perfect moment to get their products into people's hands — and your event could be it.",
  benefits: [{
    icon: Package,
    text: 'Free or discounted product delivered to your door'
  }, {
    icon: PartyPopper,
    text: 'Perfect for parties, launches & community events'
  }, {
    icon: Sparkles,
    text: 'Brands want real people to try their stuff'
  }],
  href: '/for-events',
  ctaLabel: 'Get product for your event',
  accent: 'emerald'
}];
const ACCENT_STYLES = {
  blue: {
    icon: 'text-blue-600',
    button: 'bg-primary-600 hover:bg-primary-700'
  },
  emerald: {
    icon: 'text-emerald-600',
    button: 'bg-emerald-600 hover:bg-emerald-700'
  }
} as const;
export function HostAndEventsSection() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mx-auto mb-10 max-w-3xl text-center"><h2 className="mx-auto max-w-3xl text-xl font-extrabold leading-tight text-gray-900">Not in the trade? No worries. If you love discovering new products or want to bring something special to your people or events Sizzle can help make that happen.</h2></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="py-16 lg:py-16"><div className="container mx-auto px-4 sm:px-6 lg:px-8">{t0}<div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 md:grid-cols-2">{cards.map(_temp)}</div></div></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(card) {
  const accent = ACCENT_STYLES[card.accent];
  return <div key={card.title} className="flex flex-col rounded-2xl border border-gray-100 bg-white p-6 shadow-sm sm:p-8"><span className={`inline-flex w-fit items-center gap-1.5 rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold ${accent.icon}`}><Rocket className="h-3.5 w-3.5" />Launching August 2026</span><h2 className="mt-4 text-2xl font-extrabold text-gray-900 sm:text-3xl">{card.title}</h2><p className="mt-3 text-base text-gray-500">{card.description}</p><ul className="mt-6 flex flex-col gap-3">{card.benefits.map(benefit => <li key={benefit.text} className="flex items-center gap-2 text-gray-700"><benefit.icon className={`h-5 w-5 flex-shrink-0 ${accent.icon}`} /><span className="text-sm font-medium">{benefit.text}</span></li>)}</ul><div className="mt-8 pt-2"><Link href={card.href} className={`inline-flex items-center gap-2 rounded-full px-6 py-3 font-semibold text-white shadow-md transition-all duration-200 hover:shadow-lg cursor-pointer ${accent.button}`}>{card.ctaLabel}<ArrowRight className="h-4 w-4" /></Link></div></div>;
}